import { usuario } from '../../usuario'
import { getUrlAction, notificationBox, track } from '../../utils'
import * as Sentry from '@sentry/browser'
import { estabelecimento } from '../../Estabelecimento/estabelecimento'

export const initializeFirebase = () => {

  var config = {
    apiKey: "AIzaSyB7TubD5rS9U3IKbhzaPaE59Eo45itT3k0",
    authDomain: "mogo-menu-333214.firebaseapp.com",
    projectId: "mogo-menu-333214",
    storageBucket: "mogo-menu-333214.appspot.com",
    messagingSenderId: "884835214137",
    appId: "1:884835214137:web:b14fe3608da9f15f247ee8",
    measurementId: "G-JEDMM72YQ2"
  }

  try {
    
    if(typeof firebase === 'undefined') {
      mixpanel.track('Não carregou o firebase', estabelecimento)
      return
    }

    
    if (!firebase.apps.length) {
      firebase.initializeApp(config)
    } else {
      firebase.app();
    }
    let messaging

    try {
      messaging = firebase.messaging()
    } catch {

    }

    if (messaging) {
      messaging.onMessage(function (payload) {
        console.log('Message received. ', payload)

        const notificationTitle = payload.notification.title
        const notificationOptions = {
          body: payload.notification.body,
          icon: payload.notification.icon
        }

        const hasWrapperPedidoSalvo = select('.wrapper-message-pedido-salvo')
        if (hasWrapperPedidoSalvo) {
          //Se a tela de pedido salvo estiver aberta, aguarda um tempo antes de mostrar a notificação
          setTimeout(() => {
            exibeNotificacao()
          }, 5000)
          
        } else {
          exibeNotificacao()
        }

        function exibeNotificacao() {
          //new Notification(notificationTitle, notificationOptions)
          notificationBox(payload.notification.body)

          if (typeof mixpanel != undefined) {
            mixpanel.track('Notificação recebida',
              {
                'notificationTitle': notificationTitle,
                'notificationOptions': notificationOptions
              })
          }
        }



      })
    }


    return () => {
      if (messaging && messaging.requestPermission) {
        messaging.requestPermission()

          .then(() => {
            getRegtoken && getRegtoken()
            track('Permissão notificacão', { garantida: true })
          })

          .catch(error => {
            if (error.code != 'messaging/permission-blocked') {
              Sentry.captureException(error)
            } else {
              track('Permissão notificacão', { garantida: false })
            }
            console.log(error)
          })

          .finally(() => {
            localStorage.setItem('notificacao-exibida', true)
          })

      }
    }

    function getRegtoken() {
      messaging
        .getToken()
        .then((currentToken) => {
          if (currentToken) {
            usuario && (usuario.tokenFirebase = currentToken)
            saveToken(currentToken)
          }
        })
        .catch((err) => {
          console.log('An error occurred while retrieving token. ', err)
        })
    }


    function saveToken(token) {

      if (token) {
        axios.get(getUrlAction('account', 'saveFirebaseToken'), {
          params: {
            token
          }
        }).then(res => {

        })
          .catch(err => {
            Sentry.captureException(err)
          })
      }

    }
  } catch (err) {
    Sentry.captureException(err)
  }

}
